module.exports = __webpack_public_path__ + "app/images/icons/textanzeige.svg";